import { render, staticRenderFns } from "./ContainerDetailsModal.vue?vue&type=template&id=a5d17a1c&scoped=true"
import script from "./ContainerDetailsModal.vue?vue&type=script&lang=ts"
export * from "./ContainerDetailsModal.vue?vue&type=script&lang=ts"
import style0 from "./ContainerDetailsModal.vue?vue&type=style&index=0&id=a5d17a1c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5d17a1c",
  null
  
)

export default component.exports